import React, { Component } from 'react';
import classnames from 'classnames';
import { SketchPicker } from 'react-color'

import Preview from '../Preview';

import './index.scss';

class BrandPersonalization extends Component {
  
    constructor(props){
      super(props);
      this.setWrapperRef = this.setWrapperRef.bind(this);
      this.handleClickOutside = this.handleClickOutside.bind(this);
      this.state ={
        errormessage:'Uploaded image is of not right type or dimentions',
        actioncolor:'',
        showActionpallet:false,
        showBrandpallet:false,
        image:''
      }
    }
    
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
      }
    
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
      }
    
      /**
       * Alert if clicked on outside of element
       */
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({
                showActionpallet:false,
                showBrandpallet:false,
            })
        }
      }


    fileUpload = () =>{
        const file = this.fileUploadImage.files[0];
        console.log(file);
        var reader = new FileReader();
    
        reader.onload = (upload)=>{
            console.log('image base64',upload.target.result);
            this.props.onSave(upload.target.result,'logo');
            this.setState({
                image: upload.target.result
            },function() {
                console.log('image base64',this.state.image);
            });
        };
        reader.readAsDataURL(file);
    }

    removeLogoFile=()=>{
        this.props.removeLogo();
    }
    actioncolorchange = (event) =>{
        console.log(event);
        this.setState({
            actioncolor:event.hex
        })
    }
    togglePallets=(pallet)=>{
        this.setState({
            [pallet]:!this.state[pallet]
        })
    }
    brandColorDescriptionText=(domain)=>{
            return 'Use a brand color that stands out on your website, and has good contrast with white icon. This color is used for buttons and links.';
    }
    backgroundColorDescriptionText=(domain)=>{
            return 'Use a brand color that has good contrast with white text. This color is used for calendar header.';
    }
    validateSave =()=>{
        const { props } = this.props;
        const { business_name, assistant_name, actioncolor, brandcolor } = props;
        console.log('Brand Values',business_name , assistant_name , actioncolor , brandcolor)
        if(business_name && assistant_name && actioncolor && brandcolor){
            if(business_name.trim().length>0 && assistant_name.trim().length>0 && actioncolor.trim().length>0 && brandcolor.trim().length>0 ){
                return false;
            }else{
                return true;
            }
        }else{
            return true;
        }
    }
    getFirstCharecter=(business_name)=>{
        if(business_name && business_name.length>0){
            return business_name.charAt(0)
        }
        return 'T'
    }

    render(){
        const { props, onValueChange, onSave, onCancel, webbookingconfig, auth ,business} = this.props;
        const { global_logo_file, business_name, assistant_name, actioncolor, brandcolor, greetings } = props;
        const { action_color , background_color, logo} =webbookingconfig;
        const { showActionpallet, showBrandpallet, image } = this.state;
        const { domain_keywords, domain } = auth;
      return (<div className="design">
                <div className="brand_config">
                    <div className="logo">
                        <div className="title">Logo</div>
                        <div className="description">Upload .jpg or .png image. Maximum size: 500KB. Recommended dimensions: 100x100 pixels
                        </div>
                        <div className="upload">
                                <div className={classnames('image-container',{'text-only':!global_logo_file})}>
                                {global_logo_file?(<img src={global_logo_file}/>):(<div>{business_name}</div>)}
                                </div>  
                            <div className="action-buttons">
                              <input ref={(ref) => this.fileUploadImage = ref} 
                                    onChange = {this.fileUpload}
                                      accept="image/*" 
                                      type="file" 
                                      enctype="multipart/form-data" 
                                      className="form-group" />
                              <button className="button upload"><i className="material-icons">cloud_upload</i><span>Upload your logo</span></button>
                            </div>
                            <div className="action-buttons">
                                <button className="button remove" onClick={()=>this.removeLogoFile()}>Remove</button>
                            </div>
                        </div>
                        {webbookingconfig && webbookingconfig.logoSizeerror&& <div className="errormessage">{this.state.errormessage}</div>}
                    </div>
                    <div className="logo">
                        <div className="title">Action color</div>
                        <div className="description">{this.brandColorDescriptionText(domain)}</div>
                        <div className="color-conatiner">
                            <div className="pallet" style={{backgroundColor:actioncolor}} onClick={()=>this.togglePallets('showActionpallet')}></div> <input className="input" value={actioncolor} onChange={(e)=>onValueChange(e,'actioncolor')} disabled={true}></input>
                        </div>
                        {showActionpallet &&
                        <div className="colr-picker" ref={this.setWrapperRef}>
                        <SketchPicker 
                            color={ actioncolor }
                            onChangeComplete={ (e)=>onValueChange(e,'actioncolor') }
                        />
                        </div>
                        }
                    </div>
                    
                    <div className="logo">
                        <div className="title">Background color</div>
                    <div className="description">{this.backgroundColorDescriptionText(domain)}</div>
                        <div className="color-conatiner">
                            <div className="pallet" style={{backgroundColor:brandcolor}} onClick={()=>this.togglePallets('showBrandpallet')}></div> <input className="input" value={brandcolor} onChange={(e)=>onValueChange(e,'brandcolor')} disabled={true}></input>
                        </div>
                        {showBrandpallet && 
                        <div className="colr-picker" ref={this.setWrapperRef}>
                        <SketchPicker 
                            color={ brandcolor }
                            onChangeComplete={ (e)=>onValueChange(e,'brandcolor') }
                        />
                        </div>
                        }
                    </div>
                    <div className="actions">
                      <button type="button" className="btn btn--primary btn--md first-button" onClick={(e)=>onSave(e,'brandings')} disabled={this.validateSave()}>
                          SAVE
                      </button>
                      <button type="button" className="btn btn--link button-cancel" onClick={onCancel} >
                          Cancel
                      </button>
                  </div>
                </div>
                <Preview logo={global_logo_file} auth={auth} business_name={business_name} assistant_name={assistant_name} actioncolor={actioncolor} brandcolor={brandcolor} message={greetings} usermessage/>
              </div>)
    }
};

export default BrandPersonalization;
